import { useEffect, useState } from 'react';
import API from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { Page, PageHeader } from '../../components/ui';
import ApprovisionnementIA from '../../components/appro/ApprovisionnementIA';

// Approvisionnement des établissements du propriétaire à partir des factures fournisseurs
export default function ApprovisionnementProprietaire() {
  const [etablissements, setEtablissements] = useState([]);

  useEffect(() => {
    API.get('/etablissements')
      .then(r => setEtablissements(r.data.etablissements || []))
      .catch(() => {});
  }, []);

  return (
    <AppLayout role="proprietaire">
      <Page>
        <PageHeader
          title="Approvisionnement par facture"
          subtitle="Envoyez la facture du fournisseur : StockPro prépare la mise à jour du stock"
        />
        <ApprovisionnementIA etablissements={etablissements} />
      </Page>
    </AppLayout>
  );
}
